export function useRedirectCookie() {
  return useCookie(REDIRECT_COOKIE_NAME, {
    ...AUTH_COOKIE_OPTIONS,
    httpOnly: false, // FIXME: Once we stop reading this cookie on the client, set this to true
  })
}
